<img id="logo" ngSrc="assets/img/ogi-logo.png" width="200" height="51" alt="OGI Logo" priority />
<div id="page">
  <div id="container">
    @if (tokenStatus() === TokenStatusEnum.Valid) {
      <div id="form--container">
        <mat-icon>check_circle</mat-icon>
        <h4>Email Confirmed</h4>
        <p>Your email address has been verified.</p>
        <app-button
          label="Go to login"
          buttonId="login-btn"
          [routerLink]="['/login']"
        ></app-button>
      </div>
    }
    @if (tokenStatus() === TokenStatusEnum.Validating) {
      <app-loading-spinner label="Verifying email…"></app-loading-spinner>
    }
    @if (tokenStatus() === TokenStatusEnum.Invalid) {
      <div id="validation--error">
        <mat-icon class="red-icon">error</mat-icon>
        <h4>Something went wrong</h4>
        @if (validationError()?.message) {
          <div class="error" role="alert" aria-live="assertive">
            <span>Error: </span>{{ validationError()?.message }}
          </div>
        }
      </div>
    }
  </div>
</div>
